import { createFileRoute } from '@tanstack/react-router';
import { PricingPage } from '~/components/pages/PricingPage';
import { pageHeadMeta } from '~/lib/seo';
import pricingStylesHref from '~/styles/pricing.css?url';

export const Route = createFileRoute('/pricing')({
  head: () =>
    pageHeadMeta({
      title: 'Pricing – nsave',
      description:
        "Compare nsave's Free and Pro plans. Send money internationally, get USD/GBP accounts, and invest with transparent pricing. Pro plan just $9.99/month.",
      path: '/pricing',
      stylesheets: [pricingStylesHref],
    }),
  component: PricingPage,
});
